const eventName = "rebel-session";

export const sessionListener = (callback: (signedIn: boolean) => void) => {
  window.addEventListener(
    eventName,
    (event: CustomEvent) => {
      callback(event.detail.signedIn);
    },
    false
  );
};

export const emitSessionChange = (signedIn: boolean) => {
  var event = new CustomEvent(eventName, {
    detail: {
      signedIn
    }
  });
  window.dispatchEvent(event);
};
